// extracted by mini-css-extract-plugin
export default {"dialog":"yqZ3l0DChC19tbfYx9Yp","recaptchaContainer":"SuWDEVGNpt2SMJXgQqd5","removeMargin":"E12xS7bgP5uKnm_X4ddn"};